
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsDropdown',
  components: { DesignContentLayout },
  data() {
    return {
      BUTTON_TEXT_OPTIONS: [
        { name: 'Option1', disabled: false, value: 10 },
        { name: 'Option2', disabled: false, value: 20, danger: true }
      ],
      DISABLED_BUTTON_TEXT_OPTIONS: [
        { name: 'Option1', disabled: true, value: 10 },
        { name: 'Option2', disabled: true, value: 20, danger: true }
      ],
      BUTTON_TEXT_RADIO_OPTIONS: [
        { name: 'Option1', disabled: false, value: 10 },
        { name: 'Option2', disabled: false, value: 20 },
        { name: 'Option3', disabled: false, value: 30 }
      ],
      DISABLED_BUTTON_TEXT_RADIO_OPTIONS: [
        { name: 'Option1', disabled: true, value: 10 },
        { name: 'Option2', disabled: true, value: 20 },
        { name: 'Option3', disabled: true, value: 30 }
      ],
      BUTTON_BASIC_RADIO_OPTIONS: [
        { name: 'Option1', disabled: false, value: 1 },
        { name: 'Option2', disabled: false, value: 2 },
        { name: 'Option3', disabled: false, value: 3 },
        { name: 'Option4', disabled: false, value: 4 },
        { name: 'Option5', disabled: false, value: 5 },
        { name: 'Option6', disabled: false, value: 6 },
        { name: 'Option7', disabled: false, value: 7 },
        { name: 'Option8', disabled: false, value: 8 },
        { name: 'Option9', disabled: false, value: 9 },
        { name: 'Option10', disabled: false, value: 10 },
        { name: 'Option11', disabled: false, value: 11 },
        { name: 'Option12', disabled: false, value: 12 }
      ],
      DISABLED_BUTTON_BASIC_RADIO_OPTIONS: [
        { name: 'Option1', disabled: true, value: 1 },
        { name: 'Option2', disabled: true, value: 2 },
        { name: 'Option3', disabled: true, value: 3 },
        { name: 'Option4', disabled: true, value: 4 },
        { name: 'Option5', disabled: true, value: 5 },
        { name: 'Option6', disabled: true, value: 6 },
        { name: 'Option7', disabled: true, value: 7 },
        { name: 'Option8', disabled: true, value: 8 },
        { name: 'Option9', disabled: true, value: 9 },
        { name: 'Option10', disabled: true, value: 10 },
        { name: 'Option11', disabled: true, value: 11 },
        { name: 'Option12', disabled: true, value: 12 }
      ],
      BUTTON_MULTIPLE_SELECT_OPTIONS: [
        { name: 'Option1', disabled: false, value: 1 },
        { name: 'Option2', disabled: false, value: 2 },
        { name: 'Option3', disabled: false, value: 3 },
        { name: 'Option4', disabled: false, value: 4 },
        { name: 'Option5', disabled: false, value: 5 },
        { name: 'Option6', disabled: false, value: 6 }
      ],
      DISABLED_BUTTON_MULTIPLE_SELECT_OPTIONS: [
        { name: 'Option1', disabled: true, value: 1 },
        { name: 'Option2', disabled: true, value: 2 },
        { name: 'Option3', disabled: true, value: 3 },
        { name: 'Option4', disabled: true, value: 4 },
        { name: 'Option5', disabled: true, value: 5 },
        { name: 'Option6', disabled: true, value: 6 }
      ],
      RATING_OPTIONS: [
        { name: '아주 좋아요', value: 5, disabled: false },
        { name: '좋아요', value: 4, disabled: false },
        { name: '보통이에요', value: 3, disabled: false },
        { name: '그냥 그래요', value: 2, disabled: false },
        { name: '별로예요', value: 1, disabled: false }
      ],
      DISABLED_RATING_OPTIONS: [
        { name: '아주 좋아요', value: 5, disabled: true },
        { name: '좋아요', value: 4, disabled: true },
        { name: '보통이에요', value: 3, disabled: true },
        { name: '그냥 그래요', value: 2, disabled: true },
        { name: '별로예요', value: 1, disabled: true }
      ],
      valueButtonText: null,
      valueButtonTextRadio: null,
      valueButtonBaisicRadio: null,
      valueButtonMultipleSelect: null,
      valueButtonRating: null,
      valueMenuRadioBasic: 10,
      valueMenuRadioRefresh: 1,
      valueMenuMultipleSelect: 1,
      valueMenuMultipleRating: 5
    };
  },
  methods: {
    clickInfo() {
      alert('hello');
    }
  }
};
